import { render, staticRenderFns } from "./ProductFamilyAttachItem.vue?vue&type=template&id=43716cbd&scoped=true&"
import script from "./ProductFamilyAttachItem.vue?vue&type=script&lang=js&"
export * from "./ProductFamilyAttachItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductFamilyAttachItem.vue?vue&type=style&index=0&id=43716cbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43716cbd",
  null
  
)

export default component.exports